import TableButton from "components/atoms/buttons/TableButton";
import {
  ReportHealthDetailRecorder,
  ReportHealthDetailRecorderAlert,
} from "api/interfaces/reportInterface.interface";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { getRecorderTimeFormat } from "utils/timeUtil";

import { RecorderDetail } from "../../HealthDetail";
import { ReportTable } from "components/atoms/table/AntdTable";
import { TableColumnsType } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { navigateAlertDetailPage } from "utils/AlertUtil";
import { statusToColor } from "styles/colors";
import * as mediaQuery from "components/MediaQuery";

type Props = {
  data: ReportHealthDetailRecorder;
  recorderInfo: RecorderDetail;
  timezone: string;
};

export default function Health({
  data,
  recorderInfo,
  timezone,
}: Props): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = mediaQuery.useIsMobile();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const columns: TableColumnsType<ReportHealthDetailRecorderAlert> = [
    {
      title: "Type",
      render: (value, row) => row.type,
      width: 100,
    },
    {
      title: "Alert",
      render: (value, row) =>
        row.alertReason !== "Video Loss"
          ? row.alertReason
          : `${row.alertReason} [${row.cameraName}]`,
    },
    {
      title: "Status",
      render: (value, row) => (
        <span style={{ color: statusToColor(row.status) }}>
          {row.status.toUpperCase()}
        </span>
      ),

      width: 100,
    },
    {
      key: "eventDate",
      title: "Event Time",
      render: (row) =>
        row.eventDate !== undefined
          ? getRecorderTimeFormat(
              row.eventDate,
              selectedAccount,
              timezone,
              true
            )
          : "",
      responsive: ["xl"],
      width: "18%",
    },
    {
      title: "Alert Trigger Time",
      render: (value, row) =>
        row.alertTrigger !== undefined
          ? getRecorderTimeFormat(
              row.alertTrigger,
              selectedAccount,
              timezone,
              true
            )
          : "",
      responsive: ["xl"],
      width: "18%",
    },
    {
      title: "Rule",
      render: (value, row) => row.alertName,
      responsive: ["xxl"],
      width: 100,
    },
    // 마지막 버튼
    {
      title: "",
      render: (value, row) => {
        if (row.status !== "Warning")
          return (
            <div className="table-button-wrapper">
              <TableButton
                label="View"
                onClick={() => onRowClick(row)}
                data-testid="reports-view-type-table-button-row"
              />
            </div>
          );
      },
      align: "right",
      width: isMobile ? 50 : 100,
    },
  ];

  const onRowClick = (row: ReportHealthDetailRecorderAlert) => {
    navigateAlertDetailPage({
      location,
      navigate,
      accountId: selectedAccount.accountId as string,
      recorderId: recorderInfo.recorderId,
      historyId: row.alertHistoryId,
      alertType: row.type,
      cameraId: row.cameraId,
      channel: row.cameraChannel,
    });
  };
  return (
    <ReportTable
      columns={columns}
      dataSource={data.alerts ?? []}
      loading={false}
    />
  );
}
